import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import DevelopersLeadPage from "./pages/DevelopersLeadPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Modal from "./components/Modal";
import AppContext from "./Context/AppContext";

import "./App.css";

function App() {
  let location = useLocation();
  const { pathname } = location;

  const [formData, setFormData] = useState({});
  const [referral, setReferral] = useState(null);
  const [trackingCode, setTrackingCode] = useState("");
  const [modal, setModal] = useState({ modalOpen: false, modalContent: null });

  useEffect(() => {
    const root = document.getElementById("root");
    root.classList.add("flex", "flex-col", "min-h-screen");

    const main = document.getElementsByTagName("main")[0];
    main.classList.add("flex-1");
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    setReferral(
      params.get("ref")
        ? params.get("ref")
        : pathname === "/taylor-wimpey" || pathname === "/taylor-wimpey/"
        ? "t"
        : pathname === "/persimmon" || pathname === "/persimmon/"
        ? "p"
        : null
    );

    setTrackingCode(
      pathname === "/taylor-wimpey" ||
        pathname === "/taylor-wimpey/" ||
        params.get("ref") === "t"
        ? "CABATJU24"
        : pathname === "/persimmon" ||
          pathname === "/persimmon/" ||
          params.get("ref") === "p"
        ? "CABAPJU24"
        : pathname === "/enquiries" || pathname === "/enquiries/"
        ? "CADLJU24"
        : "CABAGJU24"
    );
  }, []);

  const handleFormData = (updatedData) => {
    setFormData({ ...formData, ...updatedData });
  };

  const handleSetModal = (object) => {
    setModal(object);
  };

  return (
    <AppContext.Provider
      value={{
        formData: formData,
        setFormData: handleFormData,
        referral: referral,
        modal: modal,
        trackingCode: trackingCode,
        setModal: handleSetModal,
      }}
    >
      <>
        <Header />
        <main>
          <div className="mt-16">
            <Routes>
              <Route path="/" element={<ContactPage />} />
              <Route path="/persimmon" element={<ContactPage />} />
              <Route path="/taylor-wimpey" element={<ContactPage />} />
              <Route path="/enquiries" element={<DevelopersLeadPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </main>
        <Footer />
        <Modal modal={modal} />
      </>
    </AppContext.Provider>
  );
}

export default App;
